import i18n from '../i18n.js'
import { GAP_ALL_DAY } from '../settings.js'

const allDayLabel = {
  en: 'all day',
  de: 'ganztägig'
}[i18n.locale]

export default function (gap, includeStart = true, includeEnd = true, isLast = false) {
  if (gap === GAP_ALL_DAY) {
    return allDayLabel
  }

  if (gap === 0) {
    gap = 1
  }

  let result = ''

  if (includeStart) {
    const startHour = Math.floor(gap / 4)
    const startMinutes = ((gap - 1) % 4) * 15
    result += ((startHour < 10) ? '0' + startHour : startHour) + ':' + ((startMinutes === 0) ? '00' : startMinutes)
  }

  if (includeEnd) {
    let gapLength = 1 // 30 minutes - TH 13.05.2020

    // This is added because of the shorter gap length (see above) the closing hour is calculated wrong.
    if (isLast === true) {
      gapLength += 2
    }

    let endHour = Math.floor((gap + gapLength) / 4)
    const endMinutes = ((gap + gapLength) % 4) * 15

    if (endHour >= 24) {
      endHour -= 24
    }

    if (includeStart) {
      result += ' – '
    }

    result += ((endHour < 10) ? '0' + endHour : endHour) + ':' + ((endMinutes === 0) ? '00' : endMinutes)
  }

  return result
}
